webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(17);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(2);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inBrowser = typeof window !== 'undefined';
	if (inBrowser) {
	  _vue2.default.use(__webpack_require__(31));
	}
	
	new _vue2.default({
	  router: _router2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app_index');

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(32);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _ = __webpack_require__(21);
	
	var _2 = _interopRequireDefault(_);
	
	var _versus = __webpack_require__(23);
	
	var _versus2 = _interopRequireDefault(_versus);
	
	var _help = __webpack_require__(22);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	  base: __dirname,
	  routes: [{
	    path: '/',
	    component: _2.default
	  }, {
	    path: '/measurements/versus/:code',
	    component: _versus2.default
	  }, {
	    path: '/measurements/help',
	    component: _help2.default
	  }, { path: '*', redirect: '/' }]
	});
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app'
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['name', 'value', 'minus', 'unit']
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['heads', 'avatar', 'sdate', 'value']
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['name', 'value', 'minus', 'unit']
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hello = __webpack_require__(19);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _Calc = __webpack_require__(18);
	
	var _Calc2 = _interopRequireDefault(_Calc);
	
	var _Standard = __webpack_require__(20);
	
	var _Standard2 = _interopRequireDefault(_Standard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'versus',
	  components: {
	    Hello: _Hello2.default,
	    Calc: _Calc2.default,
	    Standard: _Standard2.default
	  },
	  data: function data() {
	    return {
	      loading: true,
	      loadError: false,
	      result: false,
	      result_msg: ' ',
	      heads: {},
	      calcs: [],
	      standards: [],
	      apiUrl: '/q_niu_api/mobile_web/measurements/versus/'
	    };
	  },
	
	  watch: {
	    '$route': function $route() {
	      this.getMeasure();
	    }
	  },
	
	  created: function created() {
	    this.getMeasure();
	  },
	  methods: {
	    getMeasure: function getMeasure() {
	      this.$http.get(this.apiUrl + this.$route.params.code).then(function (response) {
	        this.loading = false;
	        this.loadError = false;
	
	        if (response.body.status_code === '20000') {
	          this.result = true;
	          this.heads = response.body.heads;
	          this.calcs = response.body.calcs;
	          this.standards = response.body.standards;
	        } else {
	          this.result = false;
	          this.result_msg = response.body.message;
	        }
	      }, function (response) {
	        this.loading = false;
	        this.loadError = true;
	      });
	    }
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAqJJREFUeNrsmjFP20AUx18sdakwQerSAUG2TkBYI1VJxcIAAj5Bwycgc6cwsYYFsdUMzDU1EmyEgZ1QdWGApGVgxIkEA0N4lzvLjnWJ47xzkpP4S8/yJYr9u8vze3fvnGq320CWY2bwmBWWERZUXdg1WhXWW0/UW6aGBuewJbRNtPmYv66h2WgWdqI+GnDHLOCxjJYHNTpBq2AHqsmA8xGuoG1AMjrq/IMDutFg4I5ZFNBpSFYuWhHhbTq4Y1p4/A6j1T7Cl4YHHw+07zrrrWJ88PFCR8LLwanQH/BR+LzGzx9PAV5dCvwuwpejwR2TxeVfJOjcGcD0Am83/wBc5qgj/y0cLo0Q9EwnKVA0vehDd9p4/ukrFdwWbD3AVYQ8mVu8NKjgaZH0JOA8I9IfxuYNwN2B377dA3j+p+JB3RFJMOTjjmknmBWVRxkOzntyD5MvtzPzxGmB5yqboIfSHqsHXlR+i49zPDSqlwDnYWZJ6aWzhwArfwFWHwC+/FANXuA+/nuKnVwouyyL4/mr7s/OZ6nZM6xlw+uBMsncg3VGrTIG6KmsIVnYaiGtwUFX8Po7+IjBnzTkrjLwaw3B60bcCtIEqMHKdl5UOdHJTYLh0NYI3A6Du5q4SQCcFxp1GHVLljnLEz7qrqhChMB5gb0yweDlYAm6e67CS1010uVlCwZWsqCphmyVqEkWbf3JIP8f+21WY6GtflzZYr5X0ZPB/yQvlpnoxaAtWaG/X5mZDk/XNkJbsi+iCvvjhO8JHQ3uw49i/yfo05H7QINuXmVF8F9KGPpSQEeuEeLtczpmSSSqdAKjXOrnGjRwDj8DfEeZudA8Ebgh3NCKu02eIu3l820XZoUYnaiJqSmDHXoRk1LyEoL/T0S/hKDgBQSmNwEGAKaG/gSF/HVLAAAAAElFTkSuQmCC"

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/measurement01.a4d0abd.png";

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/measurement02.abba0bd.png";

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/measurement03.974d65b.png";

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(8)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(24)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(10)
	
	/* script */
	__vue_exports__ = __webpack_require__(4)
	
	/* template */
	var __vue_template__ = __webpack_require__(27)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-74225b9e"
	
	module.exports = __vue_exports__


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(12)
	
	/* script */
	__vue_exports__ = __webpack_require__(5)
	
	/* template */
	var __vue_template__ = __webpack_require__(30)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e0d599b4"
	
	module.exports = __vue_exports__


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(6)
	
	/* template */
	var __vue_template__ = __webpack_require__(28)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(25)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(26)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-70de5799"
	
	module.exports = __vue_exports__


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(11)
	
	/* script */
	__vue_exports__ = __webpack_require__(7)
	
	/* template */
	var __vue_template__ = __webpack_require__(29)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', [_h('router-view')])
	},staticRenderFns: []}

/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', ["404"])
	},staticRenderFns: []}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "help"
	  }, [_h('p', ["产品采用BIA（生物电阻测量法）技术进行人体成分的测量，如下可能会导致测量误差哦！请参考如下正确的方式测量。"]), " ", _h('div', {
	    staticClass: "clearfix rol-div"
	  }, [_h('div', [_h('img', {
	    staticClass: "measurement",
	    attrs: {
	      "alt": "image",
	      "src": __webpack_require__(14)
	    }
	  })]), " ", _h('div', ["正确测量方式，光脚测量，两脚分别站在两边的导电极片上，并保持身体稳定不晃动。"])]), " ", _h('div', {
	    staticClass: "clearfix rol-div"
	  }, [_h('div', [_h('img', {
	    staticClass: "measurement",
	    attrs: {
	      "alt": "image",
	      "src": __webpack_require__(15)
	    }
	  })]), " ", _h('div', ["双脚距离过大或靠近边缘，会导致体脂率无法测量或测量不准。"])]), " ", _h('div', {
	    staticClass: "clearfix rol-div"
	  }, [_h('div', [_h('img', {
	    staticClass: "measurement",
	    attrs: {
	      "alt": "image",
	      "src": __webpack_require__(16)
	    }
	  })]), " ", _h('div', ["双脚过于紧挨并拢，会导致体脂率测量不准。"])]), " ", _h('div', {
	    staticClass: "clearfix info"
	  }, [_h('div', [_h('img', {
	    attrs: {
	      "height": "25px",
	      "width": "25px",
	      "alt": "image",
	      "src": __webpack_require__(13)
	    }
	  })]), " ", _h('div', ["温馨提示"])]), " ", _h('div', {
	    staticClass: "last-content"
	  }, ["每天测量尽量在同一个位置会提高测量精度！"])])
	}]}

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "hello"
	  }, [_h('div', [_h('div', {
	    staticClass: "calc_name"
	  }, [_h('span', {
	    staticClass: "font_name"
	  }, [_vm._s(_vm.name)])]), " ", " ", _h('div', {
	    staticClass: "clear"
	  })]), " ", _h('div', [_h('div', {
	    staticClass: "minus_value"
	  }, [_h('div', [_h('ul', {
	    class: _vm.minus > 0 ? 'font_red' : 'font_green',
	    staticStyle: {
	      "text-align": "left",
	      "padding-top": "20px"
	    }
	  }, [_h('li', {
	    staticClass: "font_minus"
	  }, [" " + _vm._s(_vm.minus > 0 ? '+' + _vm.minus : _vm.minus)]), " ", _h('li', {
	    staticClass: "font_unit"
	  }, [_vm._s(_vm.unit)])]), " ", _h('ul', {
	    staticStyle: {
	      "padding-top": "22px"
	    }
	  }, [_h('li', {
	    staticClass: "font_value"
	  }, [_vm._s(_vm.value[0])]), _h('li', {
	    staticClass: "font_unit_s"
	  }, [_vm._s(_vm.unit)]), " ", _h('li', {
	    class: _vm.minus > 0 ? 'accow_red' : 'accow_green'
	  }), " ", _h('li', {
	    staticClass: "font_value"
	  }, [_vm._s(_vm.value[1])]), _h('li', {
	    staticClass: "font_unit_s"
	  }, [_vm._s(_vm.unit)])])])]), " ", (_vm.minus === 0) ? _h('div') : _h('div', {
	    class: _vm.minus > 0 ? 'arrow_big_red' : 'arrow_big'
	  }), " ", " ", _h('div', {
	    staticClass: "clear"
	  })])])
	},staticRenderFns: []}

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "hello"
	  }, [_h('div', [_h('div', {
	    staticClass: "calc_name"
	  }, [_h('span', {
	    staticClass: "font_name"
	  }, [_vm._s(_vm.name)])]), " ", (_vm.minus === 0) ? _h('div') : _h('div', {
	    class: _vm.minus > 0 ? 'calc_accow_red' : 'calc_accow'
	  }), " ", " ", _h('div', {
	    staticClass: "clear"
	  })]), " ", _h('div', [_h('div', {
	    staticStyle: {
	      "float": "left",
	      "padding-top": "20px"
	    }
	  }, [_h('ul', {
	    class: _vm.minus > 0 ? 'font_red' : 'font_green',
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_h('span', {
	    staticClass: "font_minus"
	  }, [" " + _vm._s(_vm.minus > 0 ? '+' + _vm.minus : _vm.minus)]), " ", _h('span', {
	    staticClass: "font_unit"
	  }, [_vm._s(_vm.unit)])])]), " ", _h('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_h('ul', {
	    staticStyle: {
	      "padding-top": "26px"
	    }
	  }, [_h('li', {
	    staticClass: "font_value_s"
	  }, [_vm._s(_vm.value[0])]), _h('li', {
	    staticClass: "font_unit_s"
	  }, [_vm._s(_vm.unit)]), " ", (_vm.minus === 0) ? _h('li', {
	    staticClass: "accow_gray"
	  }) : _h('li', {
	    class: _vm.minus > 0 ? 'accow_red' : 'accow_green'
	  }), " ", " ", _h('li', {
	    staticClass: "font_value_s"
	  }, [_vm._s(_vm.value[1])]), _h('li', {
	    staticClass: "font_unit_s"
	  }, [_vm._s(_vm.unit)])])]), " ", _h('div', {
	    staticClass: "clear"
	  })])])
	},staticRenderFns: []}

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.loading) ? _h('div', ["Loading... "]) : _vm._e(), " ", (!_vm.result) ? _h('div', [_vm._s(_vm.result_msg)]) : _vm._e(), " ", (_vm.loadError) ? _h('div', ["数据加载失败, 请稍候再试"]) : _vm._e(), " ", (_vm.result) ? _h('div', {
	    attrs: {
	      "id": "home"
	    }
	  }, [_h('hello', {
	    attrs: {
	      "heads": _vm.heads
	    }
	  }), " ", _vm._l((_vm.calcs), function(calc) {
	    return _h('calc', {
	      attrs: {
	        "name": calc.name,
	        "value": calc.value,
	        "minus": calc.minus,
	        "unit": calc.unit
	      }
	    })
	  }), " ", _vm._l((_vm.standards), function(standard) {
	    return _h('standard', {
	      attrs: {
	        "name": standard.name,
	        "value": standard.value,
	        "minus": standard.minus,
	        "unit": standard.unit
	      }
	    })
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', [_h('div', [_h('div', {
	    staticClass: "head_img"
	  }, [_h('img', {
	    staticStyle: {
	      "width": "100px",
	      "height": "100px"
	    },
	    attrs: {
	      "src": _vm.heads.avatar
	    }
	  })]), " ", _h('div', {
	    staticClass: "head_name"
	  }, [_h('span', [" " + _vm._s(_vm.heads.name)])]), " ", _vm._m(0)]), " ", _h('div', {
	    staticClass: "hello"
	  }, [_h('div', {
	    staticClass: "score"
	  }, [_h('ul', {
	    staticClass: "score_date"
	  }, [_h('li', [_vm._s(_vm.heads.score_date[0])]), " ", _h('li', [_vm._s(_vm.heads.score_date[1])])]), " ", _h('ul', {
	    staticClass: "score_value"
	  }, [_h('li', [_vm._s(_vm.heads.score_value[0]) + " ", _h('span', {
	    staticClass: "per"
	  }, ["分"])]), " ", _h('li', [_vm._s(_vm.heads.score_value[1]) + " ", _h('span', {
	    staticClass: "per"
	  }, ["分"])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "vs"
	  }, [_h('ul', {
	    staticClass: "head_vs"
	  }, [_h('li', [" 上次的你 "]), " ", _h('li', [" 这次的你 "])])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.da433d98fc888ef5e20e.js